import React from 'react';
import { XLogo, TelegramLogo, LinkedinLogo } from '@phosphor-icons/react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import SupportCard from '../../components/SupportCard';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import '../../HelpCenter.css';

/**
 * Community Category Page
 */
const Community = () => {
  const cards = [
    {
      title: 'X (Twitter)',
      description: 'Follow us on X for the latest updates and announcements.',
      icon: XLogo,
      href: 'https://x.com/wesplit_io'
    },
    {
      title: 'Telegram',
      description: 'Join our Telegram community to connect with other users.',
      icon: TelegramLogo,
      href: 'https://t.me/+v-e8orBns-llNThk'
    },
    {
      title: 'LinkedIn',
      description: 'Connect with us on LinkedIn for professional updates.',
      icon: LinkedinLogo,
      href: 'https://www.linkedin.com/company/wesplit-io/'
    }
  ];

  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-center">
        <div className="help-center-container">
          <header className="lp-section-header">
            <h1 className="lp-section-title">Community</h1>
            <p className="lp-section-subtitle">
              Join the conversation and help us shape the future of WeSplit.
            </p>
          </header>

          <section className="help-center-categories">
            <div className="help-center-cards">
              {cards.map((card, index) => (
                <SupportCard
                  key={index}
                  title={card.title}
                  description={card.description}
                  icon={card.icon}
                  href={card.href}
                />
              ))}
            </div>
          </section>

          <LastUpdated />
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default Community;
